// extracted by mini-css-extract-plugin
export var label = "_fd-5";
export var slideContainer = "_fd-0";
export var slider = "_fd-1";
export var sliderLg = "_fd-4";
export var sliderMd = "_fd-3";
export var sliderSm = "_fd-2";